import type { CSSProperties } from 'react';
import styled from 'styled-components';

import { tabletAndAbove } from '#src/style/mediaQuery.ts';

import blDesktop from './assets/bl-desktop.webp';
import blMobile from './assets/bl-mobile.webp';

type Props = {
  overlayStartColor?: string;
  overlayMidColor: string;
  className?: string;
};

const Root = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  isolation: isolate;
  z-index: -1;
`;

const GradientLayer = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    var(--overlay-start),
    var(--overlay-mid) 44vh,
    var(--c-dark-primary) var(--100vh)
  );
`;

const ImageLayerOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: var(--100vh);
  background: linear-gradient(
    to top,
    var(--c-dark-primary) 0,
    transparent 50px
  );
`;

const ImageLayer = styled.div`
  position: absolute;
  inset: 0;
  --bg-image: url(${blMobile});
  background-image: var(--bg-image);
  background-size: 100% var(--100vh);
  background-position: center top;
  background-repeat: no-repeat;
  mix-blend-mode: screen;

  @media ${tabletAndAbove} {
    --bg-image: url(${blDesktop});
  }
`;

export const SecondaryPageBackground = ({
  overlayStartColor = 'var(--c-black)',
  overlayMidColor,
  className,
}: Props) => (
  <Root
    style={
      {
        '--overlay-start': overlayStartColor,
        '--overlay-mid': overlayMidColor,
      } as CSSProperties
    }
    className={className}
    aria-hidden
  >
    <GradientLayer />
    <ImageLayer />
    <ImageLayerOverlay />
  </Root>
);
